import { validator } from "@/utils/validator";
import { ESpecificSkillCertificateType } from "@/types/enum";

export const masterDataCreateSpecificSkillCertificateSchema = validator.object().shape({
  certificateName: validator.string().trim().emptyToNull().label("特定技能合格証").required(),
  certificateType: validator.string().trim().isSelection().oneOf(Object.values(ESpecificSkillCertificateType)).label("1号or2号").required(),
  description: validator.string().trim().emptyToNull().label("説明").nullable().optional(),
  companyIndustryIds: validator.array().of(validator.number().required()).min(1, "「分野を選択してください。」").label("分野").required(),
});

export const masterDataUpdateSpecificSkillCertificateSchema = validator.object().shape({
  certificateName: validator.string().trim().emptyToNull().label("特定技能合格証").required(),
  certificateType: validator.string().trim().isSelection().oneOf(Object.values(ESpecificSkillCertificateType)).label("1号or2号").required(),
  description: validator.string().trim().emptyToNull().label("説明").nullable().optional(),
  specificSkillCertificateCompanySpecificIndustries: validator
    .array()
    .of(
      validator.object().shape({
        companySpecificIndustryId: validator.number().label("分野").required(),
      }),
    )
    .label("分野")
    .required(),
});

export const certificateIndustryRelationSchema = validator.object().shape({
  companySpecificIndustryId: validator.number().label("分野").required("「分野を選択してください。」"),
});
